import { render, staticRenderFns } from "./RicercaAcquisti.vue?vue&type=template&id=2a10da5e&scoped=true&"
import script from "./RicercaAcquisti.vue?vue&type=script&lang=js&"
export * from "./RicercaAcquisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10da5e",
  null
  
)

export default component.exports